<template>
    <div class="header-right-menu">
      <div class="right-menu" v-if="isLoggedIn">
        <notifications></notifications>
        <div class="user-profile">
          <a class="user-img"
             data-toggle="collapse" data-target="#navbarSupportedContent" id="navbarSupportedButton"
             aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <avatar v-bind:username="user.name"  v-bind:src="'/storage/' + user.photo" v-if="user.name" :size="45"></avatar>
          </a>
          <div class="dropdown-box collapse" id="navbarSupportedContent" >
            <div class="user-dropdown">
              <div class="analystHub-btn">
                <div class="analystHub-version">Analyst Hub <span>BETA</span></div>
              </div>
              <div class="dropdown-profile-info">
                <div class="user-img">
                  <avatar v-bind:username="user.name" v-bind:src="'/storage/' + user.photo"  v-if="user.name" :size="45"></avatar>
                </div>
                <div class="dropdown-user-info">
                  <h6>{{ user.name }}</h6>
                  <p class="text-word-break">{{ user.email }}</p>
                </div>
              </div>
              <div class="dropdown-menu-list">
                <!-- li class="active" -->
                <ul>
                  <li>
                    <a href="/manage-account" class="manage-account-link">Manage Account</a>
                  </li>
                  <li>
                    <a href="/learn" class="manage-account-link">Learn</a>
                  </li>
                  <li><a href="mailto:analysthub@enterprisedna.co">Get Help</a></li>
                  <li>
                    <a @click="signOut()">
                      Sign Out
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="right-menu"  v-if="!isLoggedIn">
        <a href="https://enterprisedna.co/login" class="guest-link">Log in</a>
<!--        <a href="/register" class="guest-link btn btn-outline-primary">SIGN UP FREE</a>-->
      </div>
      <div class="menu-toggle-btn">
            <span class="menu-toggle-icon">
                <span></span>
                <span></span>
                <span></span>
            </span>
      </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import ApiService from "../api/api.service";
import Avatar from 'vue-avatar';
import Notifications from "../components/Notifications";

export default {
    name: "LandingPageHeader",
    components: {
        Avatar,
        Notifications
    },
    data: function () {
        return {
            profilePopUp: false,
            notifsPopUp: false,
            user: {
                name: null,
                email: null,
                photo: null,
            },
            activeTeam: false,
            team: false,
            initSwitchToNormal: false,
        };
    },
    computed: {
        ...mapGetters({
            isLoggedIn: "isLoggedIn"
        })
    },
    async mounted() {
      await this.me()
        if(this.isLoggedIn) {
            this.userData();
        }
    },
    methods: {
        ...mapActions(['me']),
        userData() {
            ApiService.setHeader();
            ApiService.get('/api/user').then(({data}) => {
                this.user.name = data.name;
                this.user.email = data.email;
                this.user.photo = data.photo;
            }).catch(error => {
                throw new Error('failed to load user');
            });
        },
        signOut() {
            this.$store
                .dispatch("logout")
                .then(() => window.location.reload());

        },
    },

}
</script>

<style scoped>

.right-menu .upgrade-link {
    margin-right: 33px;
    margin-top: 5px;
    min-width: 85px;
}
.sub-badge {
    font-size: 9px;
    font-weight: 500;
    text-transform: uppercase;
    padding: 6px 9px 5px 9px;
    border-radius: 3px;
    margin-top: 1px;
    font-family: 'Fira Sans', sans-serif;
    font-weight: 400;
}

.sub-badge.free {
    color: #1e73bd;
    background-color: #ffffff;
    border: 1px solid #1e73bd;
}
.sub-badge.professional {
    color: #ffffff;
    background-color: #1e73bd;
    border: 1px solid #1e73bd;
}
.sub-badge.team {
    color: #ffffff;
    background-color: #23A6CD;
    border: 1px solid #23A6CD;
}
.sub-badge.enterprise {
    color: #ffffff;
    background-color: #BA8C00;
    border: 1px solid #BA8C00;
}


.dropdown-profile-active-space {
    display: flex;
    align-items: center;
    padding: 5px 36px;
    margin: 10px auto 20px auto;
}

.dropdown-profile-active-space .spaces {
    margin-top: 35px;
    display: inherit;
    position: absolute;
}

.dropdown-profile-active-space .spaces .space {
    /*border: 1px solid #DFDFDF;*/
    color: #16181f;
    display: inline-block;
    padding: 4px 9px;
}

.dropdown-profile-active-space .spaces .space:hover{
    background-color: #DFDFDF;
    cursor: pointer;
}

.dropdown-profile-active-space .spaces .space.left {
    border-radius: 4px 0 0 4px;
    cursor: pointer;
}
.dropdown-profile-active-space .spaces .space.right {
    border-radius: 0 4px 4px 0;
    border-left: none;
    cursor: pointer;
}

.dropdown-profile-active-space .spaces .space.active {
    background-color: #23A6CD;
    color: #ffffff;
}

</style>
